import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {UserConfirmationInfo} from '../../../models/user';
import {CommonService} from '../../../services/common.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {UserService} from '../../../services/user.service';
import {ConfirmDialogComponent} from '../../shared/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-user-confirmation',
    templateUrl: './user-confirmation.component.html',
    styleUrls: ['./user-confirmation.component.scss']
})
export class UserConfirmationComponent implements OnInit {
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
    @ViewChild(MatSort, {static: true}) sort: MatSort;
    columnsToDisplay = ['id', 'user_id', 'user_college_id', 'first_name', 'last_name', 'user_email', 'user_telephone', 'actions'];
    loading: boolean;
    pageTitle: any;
    pendingUsers: MatTableDataSource<UserConfirmationInfo> = new MatTableDataSource<UserConfirmationInfo>();

    constructor(public toastMessagesService: ToastMessagesService,
                private commonService: CommonService,
                public dialog: MatDialog,
                private userService: UserService) {
        this.pageTitle = 'Διαχείριση εκκρεμών χρηστών';
        this.loading = false;
    }

    async ngOnInit() {
        this.commonService.setPaginatorTexts(this.paginator);
        await this.initPendingUsers();
    }
    async initPendingUsers() {
        try {
            this.loading = true;
            this.pendingUsers = new MatTableDataSource<UserConfirmationInfo>(await this.userService.getPendingUsers());
            this.pendingUsers.sort = this.sort;
            this.pendingUsers.paginator = this.paginator;
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
            this.loading = false;
        }
    }

    activateUser(user: UserConfirmationInfo) {
        const confirm = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: 'Ενεργοποίηση χρήστη',
                message: `Είστε σίγουροι ότι θέλετε να ενεργοποιήσετε τον χρήστη ${user.first_name} ${user.last_name}?`,
                icon: 'update',
                color: 'blue'
            }
        });

        confirm.afterClosed().subscribe(async (result: any) => {
            if (result) {
                try {
                    await this.userService.updatePendingUser(user);
                    this.toastMessagesService.toastMessages('Ο χρήστη ενεργοποιήθηκε με επιτυχία');
                    await this.initPendingUsers();
                } catch (e) {
                    this.toastMessagesService.toastErrorMessage(e.message);
                }
            }
        });
    }

    sendEmail(user: UserConfirmationInfo) {

    }
}
